import { gql } from "graphql-request";

export const productCategoryData = {
  categoryCode: "",
  categoryName: "",
  description: "",

  categoryCodeStatus: "unchecked",
  categoryNameStatus: "unchecked",
  descriptionStatus: "unchecked",
};

export const productCategoryDataMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "categoryCode": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          categoryCode: value,
          categoryCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          categoryCode: "",
          categoryCodeStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          categoryCode: value,
          categoryCodeStatus: "error",
        };
      }
    }
    case "categoryName": {
      const alphaNLenghthRegex = new RegExp("^(.{1,155550})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          categoryName: value,
          categoryNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          categoryName: "",
          categoryNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          categoryName: value,
          categoryNameStatus: "error",
        };
      }
    }
    case "description": {
      const alphaNLenghthRegex = new RegExp("^.{1,10000}$", "s");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          description: value,
          descriptionStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          description: "",
          descriptionStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          description: value,
          descriptionStatus: "error",
        };
      }
    }

    default:
      return state;
  }
};

export const createProductCategory = gql`
  mutation createproductcategory($input: CreateProductCategoryInput!) {
    createProductCategory(input: $input) {
      success

      message
    }
  }
`;

export const allProductCategories = gql`
  query {
    allProductCategories {
      data {
        id

        categoryCode

        categoryName

        categoryDescription

        createdAt

        lastupdate

        user {
          id
          employeeName
        }
      }

      success

      error

      message
    }
  }
`;

export const updateProductCategory = gql`
  mutation updateproductcategory($input: UpdateProductCategoryInput!) {
    updateProductCategory(input: $input) {
      success

      message
    }
  }
`;
